/**
 * credenciamento.ts — Edital de Chamamento Público de Credenciamento
 * (art. 78, I c/c art. 79): documento gerado e geração (fase Edital).
 */

import type { components } from './generated/api'
import { api } from './http'

export type DocumentoCredenciamento =
  components['schemas']['DocumentoCredenciamento']
export type NovoCredenciamento = components['schemas']['NovoCredenciamento']
export type ParametrosCredenciamento =
  components['schemas']['ParametrosCredenciamentoInput']
export type GeracaoCredenciamento =
  components['schemas']['GeracaoCredenciamento']

export function documentoCredenciamento(id: number) {
  return api<DocumentoCredenciamento>(`/api/v1/credenciamento/${id}`)
}

export function excluirCredenciamento(id: number) {
  return api<{ excluido: boolean }>(`/api/v1/credenciamento/${id}`, {
    method: 'DELETE',
  })
}

export function novoCredenciamento(id: number) {
  return api<NovoCredenciamento>(`/api/v1/credenciamento/${id}/novo`)
}

export function gerarCredenciamento(
  id: number,
  parametros: ParametrosCredenciamento,
) {
  return api<GeracaoCredenciamento>(`/api/v1/credenciamento/${id}/gerar`, {
    method: 'POST',
    body: parametros,
  })
}
